export default __webpack_public_path__ + "static/media/aatcc.a29390f2.jpg";